import { rootRoute } from './root'
import { communityRoute } from './community'
import { feedbackRoute } from './feedback'

export const productRoute = rootRoute.addChildren([communityRoute, feedbackRoute])
